'use strict';

function handle() {
  self.wix.__INTERNAL__.triggerOnRender();
}

module.exports = {
  handle: handle
};



// WEBPACK FOOTER //
// ./src/main/worker/renderHandler.js